import { getTheme, mergeStyleSets } from '@fluentui/react';

interface ISettingTopicPageClassNames {
    settingTopicPageContainer: string;
}

export const useClassNames = (): ISettingTopicPageClassNames => {
    const applicationTheme = getTheme();

    return mergeStyleSets({
        settingTopicPageContainer: {
            background: applicationTheme.semanticColors.bodyBackground
        }
    });
}